<script setup>
import { useRouter } from 'vue-router';

const props = defineProps({
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
});
const router = useRouter();
const goBack = () => {
  if (props.backUrl !== '') {
    if (router) {
      router.push(props.backUrl);
    } else {
      window.history.back();
    }
  } else if (router) {
    router.go(-1);
  } else {
    window.history.back();
  }
};

const buttonStyleClass = props.compact ? 'text-sm' : 'text-base';
</script>

<template>
  <button
    class="flex items-center p-0 font-normal cursor-pointer text-n-slate-11"
    :class="buttonStyleClass"
    @click.capture="goBack"
  >
    <i class="i-lucide-chevron-left -ml-1 text-lg" />
    {{ buttonLabel || $t('GENERAL_SETTINGS.BACK') }}
  </button>
</template>
